import React from "react";
import classnames from "classnames";
import HeaderValue from "./HeaderValue";
import "./Table.scss";
import { useFixed, useFixedWidth } from "./hooks";

import Loader from "../Loader/Loader";

const SimpleTable = ({
  columns,
  sortBy,
  sortOrder,
  onSortChange,
  loading,
  children,
  className
}) => {
  const [fixed, setFixed, headRef, style] = useFixed();
  useFixedWidth(loading, headRef);

  return (
    <table
      className={classnames("table", className, { "fixed-fix": fixed })}
      ref={headRef}
    >
      <thead className={classnames({ "fixed-thead": fixed })} style={style}>
        <tr>
          {columns.map(columnInfo => {
            return (
              <th
                className={columnInfo.className}
                colSpan={columnInfo.colSpan}
                key={columnInfo.accessor || columnInfo._key}
              >
                <HeaderValue
                  sortBy={sortBy}
                  sortOrder={sortOrder}
                  accessor={columnInfo.accessor}
                  onSortChange={onSortChange}
                >
                  {columnInfo.renderHeaderCell
                    ? columnInfo.renderHeaderCell({})
                    : columnInfo.title}
                </HeaderValue>
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={columns.length}>
              <Loader />
            </td>
          </tr>
        ) : (
          children
        )}
      </tbody>
    </table>
  );
};

export default SimpleTable;
